package com.eladfinish.bible.contest.platform.device

import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.events.Event
import kotlin.js.Promise

/**
 * Keeps the screen awake through the Screen Wake Lock API, on the browsers that have it. The
 * browser drops the lock by itself whenever the tab is hidden, so it is requested again when the
 * tab comes back while still wanted.
 */
class WebKeepScreenOnService : KeepScreenOnService {

    private var wanted = false
    private var sentinel: dynamic = null

    private val onVisibilityChange: (Event) -> Unit = {
        if (wanted && document.asDynamic().visibilityState == "visible") acquire()
    }

    override fun setKeepScreenOn(enabled: Boolean) {
        if (wanted == enabled) return
        wanted = enabled
        if (enabled) {
            document.addEventListener("visibilitychange", onVisibilityChange)
            acquire()
        } else {
            document.removeEventListener("visibilitychange", onVisibilityChange)
            release()
        }
    }

    private fun acquire() {
        val wakeLock = window.navigator.asDynamic().wakeLock ?: return
        try {
            wakeLock.request("screen").unsafeCast<Promise<Any>>()
                .then<Unit> { lock ->
                    // Turned off again while the request was pending.
                    if (wanted) sentinel = lock else lock.asDynamic().release()
                }
                .catch { /* refused: low battery, power-save mode, or the tab is hidden */ }
        } catch (_: Throwable) {
        }
    }

    private fun release() {
        try {
            sentinel?.release()
        } catch (_: Throwable) {
        }
        sentinel = null
    }
}
